import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=41021925&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=41021925&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41021925",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41021925')) {
      api.createRecord('41021925', component.options)
    } else {
      api.reload('41021925', component.options)
    }
    module.hot.accept("./productInfo.vue?vue&type=template&id=41021925&scoped=true", function () {
      api.rerender('41021925', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/productManage/productInfo.vue"
export default component.exports